<div class="auto-page__body" style="margin-top: var(--spacing-s)">
    <div class="auto-page__table">
        <app-table tableName="AUTO_CURATE_MODAL" [tableData]="autoCurateModalData"></app-table>
    </div>
</div>
